import { component } from 'picoapp';
import options from '@/lib/options.js';
import getProductJson from '@/lib/getProductJson.js';

export default component((node) => {
  const opts = options(node);
  const price = node.querySelector('[data-price]');
  const comparePrice = node.querySelector('[data-compare-price]');

  // cache
  getProductJson();

  opts.onUpdate(state => {
    getProductJson().then(json => {

      function perfectMatch(variant) {
        return variant.option1 === state.options.option1 &&
          variant.option2 === state.options.option2 &&
          variant.option3 === state.options.option3;
      }

      function partialMatch(variant) {
        return variant.option1 === state.options.option1 &&
          variant.option2 === state.options.option2;
      }

      function firstMatch(variant) {
        return variant.option1 === state.options.option1;
      }

      const variant = json.variants.filter(v => {
        return perfectMatch(v) || partialMatch(v) || firstMatch(v);
      })[0];
      if (variant) {
        price.innerHTML = `£${variant.price}`;
        if(variant.compare_at_price) {
          comparePrice.innerHTML = `£${variant.compare_at_price}`;
        } else {
          comparePrice.innerHTML = ``;
        }
      } 
    });
  });
});


